import { EntryAttributesDTO, RunsAttributesDTO } from 'generated/leaderboard-client';

import { makeEntityIdentifier } from '@neptune/shared/entity-util';

import { AttributeModelConverter } from 'domain/experiment/attribute';

import { Entity } from '../entity-model';

import { EntitiesLists } from './list-for-runs-model';

export abstract class ListForRunsConverter {
  static runsAttributes = {
    fromApiToDomain(source: RunsAttributesDTO): EntitiesLists {
      const experiments: Array<Entity> = [];
      const runs: Array<Entity> = [];

      const createEntity = (source: RunsAttributesDTO, entry: EntryAttributesDTO): Entity => {
        return {
          attributes: entry.attributes.map(AttributeModelConverter.attributeFromApiToDomain),
          organizationId: source.organizationId,
          organizationName: source.organizationName,
          projectId: source.projectId,
          projectName: source.projectName,
          projectIdentifier: makeEntityIdentifier(source.organizationName, source.projectName),
          id: entry.experimentId, // experimentId is entityId
          type: 'run',
        };
      };

      if (source.experimentsAttributes !== undefined) {
        for (const experiment of Object.values(source.experimentsAttributes)) {
          experiments.push(createEntity(source, experiment));
        }
      }

      if (source.runsAttributes !== undefined) {
        for (const run of Object.values(source.runsAttributes)) {
          runs.push(createEntity(source, run));
        }
      }

      return {
        experiments,
        runs,
      };
    },
  };
}
